import { useContext } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../../context/context";
import './finance.css';


function Finance() {

    const { data, loading, error, isBY, isRU, isLocal, setModal  } = useContext(dataContext);


    const section = data.sectionsdata.find(s => s.nick === 'finance');
        const paragraphs = section ? section.paragraphsdata : [];

        if (paragraphs) {
            return (
                <section id="finance">
                    <div className="inner_block">

                        {
                            paragraphs.map((par, index) => (

                                <motion.div id={par.nick} key={index}
                                            initial={{ opacity: 0, y: 10, scale: 0.9 }}
                                            whileInView={{ opacity: 1, y: 0, scale: 1 }}
                                            viewport={{ once: true, amount: 0.25 }}
                                            transition={{ duration: 1 }}
                                >
                                    <motion.div className="paragraph__inner">
                                    <h2>{par.title}</h2>
                                    {par.text}
                                    </motion.div>
                                    {
                                        par.ul.length > 0 && (
                                            <ul>
                                                { par.ul.map((li, index) => (

                                                <li key={index}>{li}</li>

                                                ))
                                                }
                                            </ul>
                                        )
                                    }

                                    {
                                        par.nick == 'fin1' && (

                                         <button onClick={() => setModal(true)}>Получить расчет прибыли</button>

                                     )

                                    }

                                    {
                                        par.nick == 'fin3' && (

                                            <button onClick={() => setModal(true)}>Получить фин модель</button>

                                        )

                                    }

                                </motion.div>

                            ))
                        }

                     </div>
                </section>
            ) } else return (<></>);




    }

export default Finance;